import $localStorage from '@/services/storage/localStorage';
import $sessionStorage from '@/services/storage/sessionStorage';

export default (Vue, options) => {
    const calcOptions = Object.assign({useSessionStorage: false}, options);

    Vue.localStorage = $localStorage;
    Vue.sessionStorage = $sessionStorage;
    Vue.storage = calcOptions.useSessionStorage ? Vue.sessionStorage : Vue.localStorage;

    Object.defineProperties(Vue.prototype, {
        $localStorage: {
            get: () => Vue.localStorage,
        },
        $sessionStorage: {
            get: () => Vue.sessionStorage,
        },
        $storage: {
            get: () => Vue.storage,
        },
    });
};
